import Default from "../Pages/default";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import CompanyPage from "../Pages/companyPage";
import ProductPage from "../Pages/productPage";
import Register from "../Components/Users/register";
import { Status, useSession } from "../Components/sessionProvider";
import Navbar from "../Components/navbar";
import MyProducts from "../Components/Users/MyProducts";
import RegisterProduct from "../Components/Users/registerProduct";
import AccountSettings from "../Components/Users/accountSettings";
import RegisterBrand from "../Components/Users/registerBrand";
import TermsConditions from "./TermsConditions";
import PrivacyPolicy from "./PrivacyPolicy";
import Loading from "./Loading";
import RegisterItem from "../Components/Users/registerItem";
import MyDpps from "../Components/Users/MyDpps";
import ItemPage from "./itemPage";
import RegisterVariant from "../Components/Users/registerVariant";
import EditVariant from "../Components/Users/editVariant";

import ReactGA from "react-ga4";

function Landing() {
    ReactGA.initialize("G-N7540SR5JH");
    
    const {
        status,
        is_onboarded,
        ownerId
    } = useSession();
    
    //console.log(status, is_onboarded, ownerId);

    return (<>
        
        <BrowserRouter>
            {(status !== Status.LOADING) && <>
                <div className="App">
                    <Navbar />
                    <Routes>

                        {/** -------------------------- ONBOARDING pages ------------------------------------- */}

                        {(status === Status.LOADED) && !is_onboarded && ownerId === "" && <>
                            {/* Register is for registering and onboarding new user */}
                            <Route path="/register" element={<Register />} />
                            <Route path="*" element={<Navigate to="/" />} /> 
                            <Route path="/" element={<Register />} />
                        </>}

                        {(status === Status.LOADED) && !is_onboarded && ownerId !== "" && <>
                                <Route path="/register/manufacturer" element={<RegisterBrand />} />
                                <Route path="*" element={<Navigate to="/" />} /> 
                                <Route path="/" element={<RegisterBrand />} />
                            </>}

                        {/** -------------------------- ONBOARDED pages --------------------------------------- */}

                        {(status === Status.LOADED) && is_onboarded && <>
                            {/* Register manufacturer is a sub-page for creating new manufacturers*/}
                            <Route path="/register/manufacturer" element={<RegisterBrand redirectTo="/settings"/>} />
                            {/* Register product is for registering a new product (can also be used for items)*/}
                            <Route path="/register/product" element={<RegisterProduct />}/>
                            <Route path="/register/product/:productId" element={<RegisterProduct createVariant={true}/>}/>
                            <Route path="/register/variant" element={<RegisterVariant />}/>
                            <Route path="/register/variant/:productId" element={<RegisterVariant />}/>

                            <Route path="/register/item" element={<RegisterItem/>}/>
                            {/* Register product is for registering a new product (can also be used for items)*/}
                            <Route path="/edit/product/:productId" element={<RegisterProduct/>}/>
                            <Route path="/edit/variant/:variantId" element={<EditVariant/>}/>
                            <Route path="/edit/manufacturer/:manufacturerId" element={<RegisterBrand/>}/>
                            <Route path="/edit/owner/:ownerId" element={<RegisterBrand isOwner/>}/>
                            {/* Products is a sub-page for all of this user's products*/}
                            <Route path="/products" element={<MyProducts/>}/>
                            <Route path="/dpps" element={<MyDpps/>}/>
                            {/* Manufacturers is a sub-page for all of this users's manufacturers */}
                            <Route path="/settings" element={<AccountSettings />}/>
                            {/* User dashboard */}
                            <Route path="/dashboard" element={<></>}/>
                            <Route path="*" element={<Navigate to="/products" />} />
                        </>}

                        {/** -------------------------------- PUBLIC pages -------------------------------------------- */}
                        {/* Company product page for users */}
                        <Route path="/company/:company" element={<CompanyPage />} />
                        {/* Product page for users */}
                        <Route path="/product/:product" element={<ProductPage />} />
                        {/* Item page for users */}
                        <Route path="/item/:item" element={<ItemPage />} />
                        {/* Terms & conditions & Privacy Policy pages */}
                        <Route path="/termsOfService" element={<TermsConditions />} ></Route>
                        <Route path="/privacyPolicy" element={<PrivacyPolicy />} ></Route>
                        <Route path="*" element={<Navigate to="/" />} /> 
                        <Route path="/" element={<Default />} />
                    
                    </Routes>
                </div>
                
            </>}

            {status === Status.LOADING && <>
                <div className="App">
                    <Loading/>
                </div>
            </>}

        </BrowserRouter> 
    </>);
}

export default Landing;
